<template>
  <div>
    <Card>
      <template #content>
        <CoreForm
          v-model:title="form.title"
          v-model:new-attached="form.newAttached"
          v-model:published-at="form.publishedAt"
          v-model:unpublished-at="form.unpublishedAt"
          v-model:remarks="form.remarks"
          :attached-url="training?.attachedUrl"
          :errors="errors"
        />

        <div class="d-flex justify-content-center my-4">
          <BasicButton
            label="キャンセル"
            variant="secondary"
            class="me-5"
            outlined
            :disabled="loading"
            @click="backto"
          />
          <BasicButton
            label="更新"
            button-type="submit"
            :disabled="loading"
            @click="submit"
          />
        </div>
      </template>
    </Card>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import {
  useRouterUtil,
  useTrainings,
  useZodScheme,
  useGcp,
} from "/@/vue/composables";
import { BasicButton } from "/@/vue/components/Atom";
import { Form as CoreForm } from "/@/vue/components/Organisms/Users/Trainings";
import { axios } from "/@/modules/axios";
import { errorHandle } from "/@/modules/error";
import {
  TrainingCheckSchema,
  TrainingClient,
  TrainingForm,
  TrainingUpdateCheckSchema,
} from "/@/types";
import Card from "primevue/card";

const { backto, goto, id } = useRouterUtil();

function resetForm(t?: TrainingClient) {
  form.id = t?.id;
  form.title = t?.title;
  form.publishedAt = t?.publishedAt;
  form.unpublishedAt = t?.unpublishedAt;
  form.remarks = t?.remarks;
  form.newAttached = undefined;
}

const { useFormAndErrors } = useZodScheme();
const { form, errors, startValidation } =
  useFormAndErrors<TrainingForm>(TrainingCheckSchema);

watch(form, (f) => {
  if (f.title && f.title.length > 30) {
    form.title = f.title.slice(0, 30);
  }

  if (f.remarks && f.remarks.length > 1000) {
    form.remarks = f.remarks.slice(0, 1000);
  }
});

const { getTraining, updateTraining } = useTrainings();
const { data: training } = getTraining(id);

watch(training, (t) => {
  if (!form.id) {
    resetForm(t);
  }
});

startValidation.value = true;
const loading = ref(false);

const { uploadingMp4 } = useGcp();

async function submit() {
  try {
    loading.value = true;

    let q = {
      ...form,
    };

    if (form.newAttached) {
      const file = form.newAttached;
      if (!file) return;

      const { fileName } = await uploadingMp4(file);

      q = {
        ...q,
        fileName,
      };
    }

    const trainng = TrainingUpdateCheckSchema.parse(q);

    await updateTraining(trainng);

    window.alert("アップロードが完了しました");
    goto({ name: "UsersSystemAdminTrainingsIndex" });
  } catch (e) {
    errorHandle(e);
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped></style>
